export default __webpack_public_path__ + "static/media/No Equipment Needed.cf51f68a.webp";